import { Button } from "./button";
import { cn } from "../lib/utils";

export function BrandHome({ onClick, className }: { onClick: () => void; className?: string }) {
  return <Button variant="ghost" className={cn("next-brand-home", className)} aria-label="ESTET BAGS — на стартовый экран" onClick={onClick}><span>ESTET BAGS</span></Button>;
}
